var map = {
	"./MolegameObj/mole-desert.webp": 76348,
	"./MolegameObj/mole-forest.webp": 93240,
	"./MolegameObj/mole-hit.webp": 40502,
	"./MolegameObj/mole.webp": 39654,
	"./PvPTFgameObj/red_rocket.webp": 54766,
	"./PvPTFgameObj/rocket.webp": 82318,
	"./PvPgameObj/dark_blue_fish.webp": 1604,
	"./PvPgameObj/dark_green_fish.webp": 45355,
	"./PvPgameObj/green_lime.webp": 76425,
	"./PvPgameObj/green_star.webp": 88308,
	"./PvPgameObj/orange.webp": 63662,
	"./PvPgameObj/orange_star.webp": 11547,
	"./PvPgameObj/red_apple.webp": 74488,
	"./PvPgameObj/tomato.webp": 72702,
	"./SnakegameObj/orange_star.webp": 94253,
	"./SnakegameObj/red_apple.webp": 91022,
	"./desert_oasis.webp": 83157,
	"./fantasy_forest.webp": 64172,
	"./home/cover-aigame.webp": 15420,
	"./home/cover-gamesetting.webp": 63898,
	"./home/cover-mazegame.webp": 6649,
	"./home/cover-molegame.webp": 20973,
	"./home/cover-pick.webp": 32837,
	"./home/cover-punchboard.webp": 6560,
	"./home/cover-pvpgame.webp": 37412,
	"./home/cover-snakegame.webp": 30142,
	"./home/cover-tfgame.webp": 81308,
	"./ocean_world.webp": 66187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36365;